import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useApi from "../../../CustomHooks/useApi";
import { useSelector, useDispatch } from "react-redux";
import { setRemitterData } from "../../../Store/Slices/AuthSlice";

const PpiRemitter = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const remitter_mobile_number = useSelector((state) => state.auth.remitterData?.remitter_phone);
  const remitter_fullname = useSelector((state) => state.auth.remitterData?.remitter_name);
  const remitter_availableLimit = useSelector((state) => state.auth.remitterData?.remitter_data?.limitAvailable);
  const remitter_consumeLimit = useSelector((state) => state.auth.remitterData?.remitter_data?.limitConsumed);
  const remitter_limitTotal = useSelector((state) => state.auth.remitterData?.remitter_data?.limitTotal);
  const merchantid = useSelector((store) => store.auth.employeeDetails.userId);
  const impsType = useSelector((state) => state.auth.remitterData?.type);
  const username = useSelector((state) => state.auth.employeeDetails?.username);
  const onetimelimit = useSelector((store) => store?.auth?.employeeDetails?.oneTimeLimit);
  
  
  const [beneServiceMessage, setBeneServiceMessage] = useState("");


  const fetchbeneficiares = location.state?.fetchbeneficiares || false;

  const [beneficiaries, setBeneficiaries] = useState([]);
  const [beneid, setBeniId] = useState("");
  const [selectedModes, setSelectedModes] = useState({});
  const [amounts, setAmounts] = useState({});
  const [error, setError] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCheckbox, setSelectedCheckbox] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  // const { callApi } = useApi("/dmt/list/beneficiary", "GET");
  const { callApi: fetchBeneIMPS1 } = useApi("/dmt/list/beneficiary", "GET");
  const { callApi: fetchBeneIMPS2 } = useApi("/dmt/ezypay/bene/list", "GET");
  const { callApi: deletebene } = useApi("/dmt/delete/beneficiary", "PUT");
  const { callApi: remitterlimit } = useApi("/dmt/remitter-profile", "GET");


  useEffect(() => {
    fetchBeneficiaries();
    if (impsType === "IMPS2") {
      remitterlimitHandler();
    }
  }, [location.pathname, fetchbeneficiares]);

  useEffect(() => {
  if (beneficiaries.length > 0) {
    const defaultModes = {};
    beneficiaries.forEach((_, index) => {
      defaultModes[index] = "IMPS";
    });

    setSelectedModes(defaultModes);
  }
}, [beneficiaries]);

  const remitterlimitHandler = async () => {
    try {
      const response = await remitterlimit(null, `?mobileNumber=${remitter_mobile_number}&merchantId=${merchantid}`);
      console.log("Remitter Limit Response:", response);
      if (response) {
        // dispatch(setRemitterData(response));

      }
    } catch (error) {
      console.error("Failed to refresh remitter data:", error);
      setError("Failed to refresh remitter data. Please try again.");
    }
  };

  const handleCheckboxChange = (index) => {
    setError("");

    if (index === selectedCheckbox) {
      setSelectedCheckbox(null);
      setAmounts((prev) => ({
        ...prev,
        [index]: "",
      }));
      setSelectedModes((prev) => ({
        ...prev,
        [index]: "",
      }));
      setSelectedRows([]);
      return;
    }

    // setSelectedCheckbox(index);
    // setSelectedRows([
    //   {
    //     index,
    //     ...beneficiaries[index],
    //     amount: amounts[index] || "",
    //     mode: selectedModes[index] || "",
    //   },
    // ]);
    setSelectedCheckbox(index);

// ✅ FORCE IMPS MODE WHEN SELECTING ROW
setSelectedModes((prev) => ({
  ...prev,
  [index]: "IMPS",
}));

setSelectedRows([
  {
    index,
    ...beneficiaries[index],
    amount: amounts[index] || "",
    mode: "IMPS",
  },
]);
  };

  const handleDeleteBeneficiary = async () => {
    if (selectedCheckbox === null) return;

    setDeleteLoading(true);
    setError("");

    try {
      const selectedBeneficiaryId = beneid;
      const response = await deletebene(null, `?beneficiary_id=${selectedBeneficiaryId}&remitter_mobile=${remitter_mobile_number}&username=${username}`);

      if (response) {
        // Reset selection states
        setSelectedCheckbox(null);
        setSelectedRows([]);
        setAmounts({});
        setSelectedModes({});

        // Close popup
        setShowDeletePopup(false);

        // Refresh beneficiaries list
        await fetchBeneficiaries();
      } else {
        setError("Failed to delete beneficiary. Please try again.");
        setSelectedCheckbox(null);
        setSelectedRows([]);
        setAmounts({});
        setSelectedModes({});
        setShowDeletePopup(false);
      }
    } catch (error) {
      console.error("Delete beneficiary failed:", error);
      setError("Something went wrong while deleting. Please try again.");
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleDeleteClick = (beniid) => {
    if (selectedCheckbox !== null) {
      setBeniId(beniid);
      setShowDeletePopup(true);
    }
  };

  const handleCancelDelete = () => {
    setShowDeletePopup(false);
  };

  const handleModeChange = (index, mode) => {
    setSelectedModes((prev) => {
      const updatedModes = {
        ...prev,
        [index]: mode,
      };


      if (index === selectedCheckbox) {
        setSelectedRows([
          {
            index,
            ...beneficiaries[index],
            amount: amounts[index] || "",
            mode: mode,
          },
        ]);
      }

      return updatedModes;
    });
  };

  const handleAmountChange = (index, value) => {

    if (parseFloat(value) < 100) {
      setError("Please enter an amount greater than or equal to 100.");
    } else {
      setError("");
    }

    if (parseFloat(value) > onetimelimit) {
      setError(`Please enter an amount less than or equal to ${onetimelimit}`);
    } else {
      setError("");
    }

    setAmounts((prev) => {
      const updatedAmounts = {
        ...prev,
        [index]: value,
      };

      if (index === selectedCheckbox) {
        setSelectedRows([
          {
            index,
            ...beneficiaries[index],
            amount: value,
            mode: selectedModes[index] || "",
          },
        ]);
      }

      return updatedAmounts;
    });
  }


  // const fetchBeneficiaries = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await callApi(null, `?remitter_mobile=${remitter_mobile_number}`);
  //     if (response && Array.isArray(response) && response.length > 0) {
  //       setBeneficiaries(response);
  //     } else {
  //       setBeneficiaries([]);
  //     }
  //   } catch (error) {
  //     console.error("API call failed", error);
  //     setBeneficiaries([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  //   const fetchBeneficiaries = async () => {
  //     setLoading(true);
  //     try {
  //       let response;

  //       if (impsType === "IMPS1") {
  //         // ✅ IMPS1 – EZYPAY
  //         if (impsType === "IMPS1") {
  //   const response = await fetchBeneIMPS1(
  //     null,
  //     `?rem_mobile=${remitter_mobile_number}`
  //   );

  //   // ✅ normalize EZYPAY response for table
  //   const formatted = (response || []).map((b) => ({
  //     beneId: b.beneficiaryid,
  //     beneName: b.beneficiaryname,
  //     accountNumber: b.accountnumber,
  //     bankName: b.bank,
  //     ifsc: b.ifscode,
  //     status: b.benestatus === "V" ? "VERIFIED" : "PENDING",
  //     bankId: b.bank_id,
  //   }));

  //   setBeneficiaries(formatted);
  // }
  //       } else {
  //         // ✅ IMPS2 – NORMAL DMT
  //         response = await fetchBeneIMPS2(
  //           null,
  //           `?remitter_mobile=${remitter_mobile_number}`
  //         );
  //       }

  //       if (Array.isArray(response) && response.length > 0) {
  //         setBeneficiaries(response);
  //       } else {
  //         setBeneficiaries([]);
  //       }
  //     } catch (error) {
  //       console.error("Fetch beneficiaries failed:", error);
  //       setBeneficiaries([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  // const fetchBeneficiaries = async () => {
  //   setLoading(true);
  //   try {
  //     // if (impsType === "IMPS1") {
  //     //   // ✅ IMPS1 – EZYPAY
  //     //   const response = await fetchBeneIMPS1(
  //     //     null,
  //     //     `?rem_mobile=${remitter_mobile_number}`
  //     //   );

  //     //   // const formatted = (response || []).map((b) => ({
  //     //   //   beneficiaryId: b.beneficiaryid,
  //     //   //   beneficiaryName: b.beneficiaryname,
  //     //   //   accountNo: b.accountnumber,
  //     //   //   bankName: b.bank,
  //     //   //   ifscCode: b.ifscode,
  //     //   //   verificationStatus: b.benestatus === "V" ? "APPROVED" : "Pending",
  //     //   //   bankId: b.bank_id,
  //     //   // }));
  //     //   const formatted = (response || []).map((b) => ({
  //     //     bene_id: b.beneficiaryid, // ✅ renamed
  //     //     beneficiaryName: b.beneficiaryname,
  //     //     accountNo: b.accountnumber,
  //     //     bankName: b.bank,
  //     //     ifscCode: b.ifscode,
  //     //     verificationStatus: b.benestatus === "V" ? "APPROVED" : "Pending",
  //     //     bankId: b.bank_id,
  //     //   }));

  //     //   setBeneficiaries(formatted);
  //     //   return; // 🔥 IMPORTANT: STOP EXECUTION HERE
  //     // }

  //     // ✅ IMPS2 – NORMAL DMT

  //     if (impsType === "IMPS1") {
  //       const response = await fetchBeneIMPS2(
  //         null,
  //         `?rem_mobile=${remitter_mobile_number}`
  //       );

  //       // 🔴 HANDLE EZYPAY BUSINESS ERROR
  //       if (response?.errorCode === "EZYPAY_BUSINESS") {
  //         setBeneficiaries([]);
  //         setBeneServiceMessage(response.message); // ✅ store API message
  //         return;
  //       }

  //       setBeneServiceMessage(""); // ✅ clear old message if success

  //       const formatted = (response || []).map((b) => ({
  //         bene_id: b.beneficiaryid,
  //         beneficiaryName: b.beneficiaryName,
  //         accountNo: b.accountNo,
  //         bankName: b.bankName,
  //         ifscCode: b.ifscCode,
  //         verificationStatus: b.verificationStatus,
  //         bankId: b.bank_id,
  //       }));

  //       setBeneficiaries(formatted);
  //       return;
  //     }


  //     const response = await fetchBeneIMPS2(
  //       null,
  //       `?rem_mobile=${remitter_mobile_number}`
  //     );

  //     setBeneficiaries(Array.isArray(response) ? response : []);
  //   } catch (error) {
  //     console.error("Fetch beneficiaries failed:", error);
  //     setBeneficiaries([]);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchBeneficiaries = async () => {
  setLoading(true);
  try {
    const response = await fetchBeneIMPS2(
      null,
      `?rem_mobile=${remitter_mobile_number}`
    );

    // Handle business error
    if (response?.errorCode === "EZYPAY_BUSINESS") {
      setBeneficiaries([]);
      setBeneServiceMessage(response.message);
      return;
    }

    setBeneServiceMessage("");

    const formatted = (response || []).map((b) => ({
      bene_id: b.beneficiaryid,
      beneficiaryName: b.beneficiaryname,
      accountNo: b.accountnumber,
      bankName: b.bank,
      ifscCode: b.ifscode,
      verificationStatus: b.benestatus === "V" ? "APPROVED" : "Pending",
      bankId: b.bank_id,
    }));

    setBeneficiaries(formatted);
  } catch (error) {
    console.error("Fetch beneficiaries failed:", error);
    setBeneficiaries([]);
  } finally {
    setLoading(false);
  }
};


  const handleAddNewClick = () => {
    navigate("/ppiaddbeneficiary");
  };


  const handleProcess = async () => {
    if (selectedCheckbox === null) {
      setError("Please select a beneficiary first!");
      return;
    }

    const selectedMode = selectedModes[selectedCheckbox];
    const selectedAmount = amounts[selectedCheckbox];

    if (!selectedAmount) {
      setError("Please enter an amount before proceeding.");
      return;
    }

    if (parseFloat(selectedAmount) > onetimelimit) {
      setError(`Please enter an amount less than or equal to ${onetimelimit}`);
      return;
    }
    if (parseFloat(selectedAmount) < 100) {
      setError("Amount must be at least 100.");
      return;
    }


    if (!selectedMode) {
      setError("Please select a mode before proceeding.");
      return;
    }

    setError("");
    // navigate("/fundtransfer", {
    //   state: {
    //     selectedBeneficiary: selectedRows,
    //   },
    // });
    navigate("/ppifundtransfer", {
  state: {
    selectedBeneficiary: selectedRows.map(row => ({
      ...row,
      bene_id: row.bene_id,
    })),
    amount: selectedRows[0]?.amount, // ✅ PASS AMOUNT
  },
});
  };


  const getStatusClasses = (status) => {
    switch (status) {
      case "APPROVED":
        return "bg-green-100 text-green-600";
      case "Failed":
        return "bg-red-100 text-red-600";
      case "Pending":
        return "bg-yellow-100 text-yellow-600";
      default:
        return "";
    }
  };


  // return (
  //   <div className="p-8 min-h-screen">
  //     <div className="bg-white p-6 rounded-lg shadow-md">
  //       <h2 className="text-2xl font-semibold mb-2">Remitter's Details</h2>
  //       <p className="text-gray-500 text-sm mb-6">
  //         All the required information for a seamless transfer process.
  //       </p>

  //       <div className="flex justify-between items-center mb-4">
  //         <div>
  //           <p className="text-lg font-medium">
  //             Name:{" "}
  //             <span className="font-semibold">
  //               {remitter_fullname}
  //             </span>
  //           </p>

  //           <p className="text-purple-600 font-semibold">
  //             Mobile No:{" "}
  //             <span className="font-semibold">
  //               {remitter_mobile_number}
  //             </span>
  //           </p>
  //           <div className="flex flex-wrap gap-4 mt-2">
  //             <div className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-semibold flex items-center">
  //               Avl. Limit: <span className="ml-1">{remitter_availableLimit}</span>
  //             </div>
  //             <div className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-xs font-semibold flex items-center">
  //               Consumed: <span className="ml-1">{remitter_consumeLimit}</span>
  //             </div>
  //             <div className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-semibold flex items-center">
  //               Total Limit: <span className="ml-1">{remitter_limitTotal}</span>
  //             </div>
  //           </div>
  //         </div>
  //         <button className="bg-purple-600 text-white px-4 py-2 rounded-md hover:bg-purple-700"
  //           onClick={handleAddNewClick}>
  //           + Add New Beneficiary
  //         </button>
  //       </div>

  //       <div className="overflow-x-auto">
  //         <table className="w-full text-left text-gray-700">
  //           <thead>
  //             <tr className="border-b">
  //               <th className="p-2">Select</th>
  //               <th className="p-2">Mode</th>
  //               <th className="p-2">Name</th>
  //               <th className="p-2">Bank</th>
  //               <th className="p-2">Account</th>
  //               <th className="p-2">IFSC CODE</th>
  //               <th className="p-2">Status</th>
  //               <th className="p-2">Amount</th>
  //               <th className="p-2">Action</th>
  //             </tr>
  //           </thead>

  //           {loading ? (
  //             <tbody>
  //               <tr>
  //                 <td colSpan="9" className="text-center text-gray-600 text-lg p-4">
  //                   Loading data...
  //                 </td>
  //               </tr>
  //             </tbody>
  //           ) : beneficiaries.length === 0 ? (
  //             <tbody>
  //               <tr>
  //                 <td colSpan="9" className="text-center text-red-500 text-lg p-4">
  //                   No data found
  //                 </td>
  //               </tr>
  //             </tbody>
  //           ) : (
  //             <tbody>
  //               {beneficiaries.map((item, index) => (
  //                 <tr
  //                   key={item.id || index}
  //                   className={`border-b hover:bg-gray-100 ${selectedCheckbox === index ? "bg-gray-200" : ""
  //                     }`}
  //                 >
  //                   <td className="p-2">
  //                     <input
  //                       type="checkbox"
  //                       checked={selectedCheckbox === index}
  //                       onChange={() => handleCheckboxChange(index)}
  //                     />
  //                   </td>
  //                   <td className="p-2">
  //                     <div className="flex gap-2 items-center">
  //                       {/* <label>
  //                         <input
  //                           type="radio"
  //                           name={`mode-${index}`}
  //                           value="NEFT"
  //                           checked={selectedModes[index] === "NEFT"}
  //                           onChange={() => handleModeChange(index, "NEFT")}
  //                           disabled={selectedCheckbox !== index}
  //                         />
  //                         <span className="ml-1">NEFT</span>
  //                       </label> */}
  //                       <label>
  //                         <input
  //                           type="radio"
  //                           name={`mode-${index}`}
  //                           value="IMPS"
  //                           checked={selectedModes[index] === "IMPS"}
  //                           onChange={() => handleModeChange(index, "IMPS")}
  //                           disabled={selectedCheckbox !== index}
  //                         />
  //                         <span className="ml-1">IMPS</span>
  //                       </label>
  //                     </div>
  //                   </td>
  //                   <td className="p-2">{item.beneficiaryName}</td>
  //                   <td className="p-2">{item.bankName}</td>
  //                   <td className="p-2">{item.accountNo}</td>
  //                   <td className="p-2">{item.ifscCode}</td>
  //                   <td className="p-2">
  //                     <span
  //                       className={`px-3 py-1 rounded-full text-sm ${getStatusClasses(
  //                         item.verificationStatus
  //                       )}`}
  //                     >
  //                       {item.verificationStatus}
  //                     </span>
  //                   </td>
  //                   <td className="p-2 font-medium">
  //                     <input
  //                       type="text"
  //                       inputMode="numeric"
  //                       pattern="[0-9]*"
  //                       placeholder="Enter amount"
  //                       value={amounts[index] || ""}
  //                       onChange={(e) => {
  //                         const val = e.target.value;
  //                         if (/^\d{0,5}$/.test(val)) {
  //                           handleAmountChange(index, val);
  //                         }
  //                       }}
  //                       disabled={selectedCheckbox !== index}
  //                       className="border p-1 rounded w-full"
  //                     />
  //                   </td>
  //                   <td className="p-2">
  //                     <button
  //                       onClick={() => handleDeleteClick(item.beneficiaryId)}
  //                       disabled={selectedCheckbox !== index}
  //                       className={`px-3 py-1 rounded text-sm ${selectedCheckbox === index
  //                           ? "bg-red-500 text-white hover:bg-red-600"
  //                           : "bg-gray-300 text-gray-500 cursor-not-allowed"
  //                         }`}
  //                     >
  //                       Delete
  //                     </button>
  //                   </td>
  //                 </tr>
  //               ))}
  //             </tbody>
  //           )}
  //         </table>
  //         {error && <div className="text-red-500 mt-2">{error}</div>}
  //       </div>

  //       <div className="flex justify-end gap-4 mt-6">
  //         <button className="bg-purple-600 text-white px-6 py-2 rounded-md hover:bg-purple-700"
  //           onClick={handleProcess}
  //         >
  //           Proceed
  //         </button>
  //       </div>
  //     </div>

  //     {/* Delete Confirmation Popup */}
  //     {showDeletePopup && (
  //       <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  //         <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full mx-4">
  //           <h3 className="text-lg font-semibold mb-4">Confirm Delete</h3>
  //           <p className="text-gray-600 mb-6">
  //             Are you sure you want to delete this beneficiary?
  //             {selectedCheckbox !== null && beneficiaries[selectedCheckbox] && (
  //               <span className="block font-medium text-gray-800 mt-2">
  //                 {beneficiaries[selectedCheckbox].beneficiaryName}
  //               </span>
  //             )}
  //           </p>
  //           <div className="flex justify-end gap-3">
  //             <button
  //               onClick={handleCancelDelete}
  //               disabled={deleteLoading}
  //               className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 disabled:opacity-50"
  //             >
  //               Cancel
  //             </button>
  //             <button
  //               onClick={handleDeleteBeneficiary}
  //               disabled={deleteLoading}
  //               className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 disabled:opacity-50"
  //             >
  //               {deleteLoading ? "Deleting..." : "OK"}
  //             </button>
  //           </div>
  //         </div>
  //       </div>
  //     )}
  //   </div>
  // );

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-indigo-50 to-cyan-50 py-10">
      <div className="max-w-7xl mx-auto px-4 space-y-8">

        {/* ===== HEADER / REMITTER DETAILS ===== */}
        <div
          className="bg-white/90 backdrop-blur-xl rounded-3xl
                   border border-slate-200
                   shadow-[0_30px_80px_-25px_rgba(0,0,0,0.35)]
                   p-8"
        >
          <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6">
            <div>
              <h1 className="text-3xl font-semibold text-slate-900">
                Remitter Profile
              </h1>
              <p className="mt-2 text-slate-600">
                Manage beneficiaries and initiate money transfer
              </p>

              <div className="mt-4 space-y-1">
                <p className="text-lg font-medium text-slate-800">
                  {remitter_fullname}
                </p>
                <p className="text-indigo-600 font-semibold">
                  {remitter_mobile_number}
                </p>
              </div>

              {/* LIMIT PILLS */}
              {/* <div className="flex flex-wrap gap-3 mt-6">
                <span className="px-4 py-2 rounded-full text-sm font-semibold
                               bg-emerald-100 text-emerald-700">
                  Available ₹{remitter_availableLimit}
                </span>
                <span className="px-4 py-2 rounded-full text-sm font-semibold
                               bg-amber-100 text-amber-700">
                  Consumed ₹{remitter_consumeLimit}
                </span>
                <span className="px-4 py-2 rounded-full text-sm font-semibold
                               bg-indigo-100 text-indigo-700">
                  Total ₹{remitter_limitTotal}
                </span>
              </div> */}
            </div>

            <button
              onClick={handleAddNewClick}
              className="inline-flex items-center justify-center
                       px-6 py-3 rounded-xl font-semibold text-white
                       bg-gradient-to-r from-indigo-600 to-cyan-500
                       shadow-lg hover:shadow-xl transition"
            >
              + Add Beneficiary
            </button>
          </div>
        </div>

        {/* ===== BENEFICIARY TABLE ===== */}
        {/* <div className="bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left">
            <thead className="bg-slate-100">
              <tr>
                {[
                  "Select",
                  "Mode",
                  "Name",
                  "Bank",
                  "Account",
                  "IFSC",
                  "Status",
                  "Amount",
                  "Action",
                ].map((h) => (
                  <th
                    key={h}
                    className="px-4 py-3 font-semibold text-slate-600"
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-200">
              {loading ? (
                <tr>
                  <td colSpan="9" className="py-10 text-center text-slate-500">
                    Loading beneficiaries…
                  </td>
                </tr>
              ) : beneficiaries.length === 0 ? (
                <tr>
                  <td colSpan="9" className="py-10 text-center text-slate-500">
                    No beneficiaries found
                  </td>
                </tr>
              ) : (
                beneficiaries.map((item, index) => (
                  <tr
                    key={index}
                    className={`hover:bg-slate-50 transition
                      ${selectedCheckbox === index ? "bg-indigo-50" : ""}`}
                  >
                    <td className="px-4 py-3">
                      <input
                        type="checkbox"
                        checked={selectedCheckbox === index}
                        onChange={() => handleCheckboxChange(index)}
                      />
                    </td>

                    <td className="px-4 py-3">
                      <label className="inline-flex items-center gap-2">
                        <input
                          type="radio"
                          name={`mode-${index}`}
                          value="IMPS"
                          checked={selectedModes[index] === "IMPS"}
                          onChange={() => handleModeChange(index, "IMPS")}
                          disabled={selectedCheckbox !== index}
                        />
                        <span className="text-sm font-medium">IMPS</span>
                      </label>
                    </td>

                    <td className="px-4 py-3 font-medium">
                      {item.beneficiaryName}
                    </td>
                    <td className="px-4 py-3">{item.bankName}</td>
                    <td className="px-4 py-3">{item.accountNo}</td>
                    <td className="px-4 py-3">{item.ifscCode}</td>

                    <td className="px-4 py-3">
                      <span
                        className={`px-3 py-1 rounded-full text-xs font-semibold
                          ${
                            item.verificationStatus === "APPROVED"
                              ? "bg-emerald-100 text-emerald-700"
                              : item.verificationStatus === "Pending"
                              ? "bg-amber-100 text-amber-700"
                              : "bg-rose-100 text-rose-700"
                          }`}
                      >
                        {item.verificationStatus}
                      </span>
                    </td>

                    <td className="px-4 py-3">
                      <input
                        type="text"
                        inputMode="numeric"
                        placeholder="₹ Amount"
                        value={amounts[index] || ""}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (/^\d{0,5}$/.test(val)) {
                            handleAmountChange(index, val);
                          }
                        }}
                        disabled={selectedCheckbox !== index}
                        className="w-full px-3 py-2 rounded-lg border
                                   border-slate-300
                                   focus:border-indigo-600 focus:outline-none"
                      />
                    </td>

                    <td className="px-4 py-3">
                      <button
                        onClick={() => handleDeleteClick(item.beneficiaryId)}
                        disabled={selectedCheckbox !== index}
                        className={`px-3 py-1.5 rounded-lg text-xs font-semibold
                          ${
                            selectedCheckbox === index
                              ? "bg-rose-500 text-white hover:bg-rose-600"
                              : "bg-slate-200 text-slate-400 cursor-not-allowed"
                          }`}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {error && (
          <div className="px-6 py-4 text-sm text-rose-600">
            {error}
          </div>
        )}

        <div className="flex justify-end px-6 py-5 border-t border-slate-200">
          <button
            onClick={handleProcess}
            className="px-8 py-3 rounded-xl font-semibold text-white
                       bg-gradient-to-r from-indigo-600 to-cyan-500
                       shadow-lg hover:shadow-xl transition"
          >
            Proceed
          </button>
        </div>
      </div> */}
        {/* ================= BENEFICIARIES ================= */}
        <div className="bg-white rounded-3xl border border-slate-200 shadow-sm overflow-hidden">

          {/* ================= MOBILE VIEW ================= */}
          <div className="block md:hidden space-y-4 p-4">
            {loading ? (
              <p className="text-center text-slate-500">Loading beneficiaries…</p>
              // 
            ) : beneServiceMessage ? (
              <p className="text-center text-rose-600 font-medium">
                {beneServiceMessage}
              </p>
            ) : beneficiaries.length === 0 ? (
              <p className="text-center text-slate-500">No beneficiaries found</p>
            ) : (

              beneficiaries.map((item, index) => (
                <div
                  key={index}
                  className={`rounded-2xl border p-4 space-y-3
            ${selectedCheckbox === index
                      ? "border-indigo-500 bg-indigo-50"
                      : "border-slate-200 bg-white"}`}
                >
                  {/* HEADER */}
                  <div className="flex items-center justify-between">
                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={selectedCheckbox === index}
                        onChange={() => handleCheckboxChange(index)}
                      />
                      <span className="font-semibold text-slate-800">
                        {item.beneficiaryName}
                      </span>
                    </label>

                    <span
                      className={`px-3 py-1 rounded-full text-xs font-semibold
                ${item.verificationStatus === "APPROVED"
                          ? "bg-emerald-100 text-emerald-700"
                          : item.verificationStatus === "Pending"
                            ? "bg-amber-100 text-amber-700"
                            : "bg-rose-100 text-rose-700"
                        }`}
                    >
                      {item.verificationStatus}
                    </span>
                  </div>

                  {/* DETAILS */}
                  <div className="text-sm text-slate-600 space-y-1">
                    <p><b>Bank:</b> {item.bankName}</p>
                    <p><b>Account:</b> {item.accountNo}</p>
                    <p><b>IFSC:</b> {item.ifscCode}</p>
                  </div>

                  {/* MODE */}
                  <label className="flex items-center gap-2">
                    <input
                      type="radio"
                      name={`mode-mobile-${index}`}
                      // checked={selectedModes[index] === "IMPS"}
                      checked={true}
                      onChange={() => handleModeChange(index, "IMPS")}
                      disabled={selectedCheckbox !== index}
                    />
                    IMPS
                  </label>

                  {/* AMOUNT */}
                  <input
                    type="text"
                    inputMode="numeric"
                    placeholder="Enter Amount"
                    value={amounts[index] || ""}
                    disabled={selectedCheckbox !== index}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (/^\d{0,5}$/.test(val)) handleAmountChange(index, val);
                    }}
                    className="w-full px-4 py-3 rounded-xl border border-slate-300
                       focus:border-indigo-500 outline-none"
                  />

                  {/* DELETE */}
                  <button
                    onClick={() => handleDeleteClick(item.beneficiaryId)}
                    disabled={selectedCheckbox !== index}
                    className={`w-full py-2 rounded-xl text-sm font-semibold
              ${selectedCheckbox === index
                        ? "bg-rose-500 text-white"
                        : "bg-slate-200 text-slate-400"
                      }`}
                  >
                    Delete Beneficiary
                  </button>
                </div>
              ))
            )}

            {error && <p className="text-rose-600 text-sm">{error}</p>}

            <button
              onClick={handleProcess}
              className="w-full py-4 rounded-2xl text-white font-semibold
                 bg-gradient-to-r from-indigo-600 to-cyan-500 shadow-lg"
            >
              Proceed
            </button>
          </div>

          {/* ================= DESKTOP VIEW ================= */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full text-sm text-left">
              <thead className="bg-slate-100">
                <tr>
                  {["Select", "Mode", "Name", "Bank", "Account", "IFSC", "Status", "Amount", "Action"].map(h => (
                    <th key={h} className="px-4 py-3 font-semibold text-slate-600">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody className="divide-y divide-slate-200">
                {loading ? (
                  <tr>
                    <td colSpan="9" className="py-10 text-center text-slate-500">
                      Loading beneficiaries…
                    </td>
                  </tr>
                  // 
                ) : beneServiceMessage ? (
                  <tr>
                    <td colSpan="9" className="py-10 text-center text-rose-600 font-medium">
                      {beneServiceMessage}
                    </td>
                  </tr>
                ) : beneficiaries.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="py-10 text-center text-slate-500">
                      No beneficiaries found
                    </td>
                  </tr>
                ) : (
                  beneficiaries.map((item, index) => (
                    <tr
                      key={index}
                      className={`hover:bg-slate-50 transition
                ${selectedCheckbox === index ? "bg-indigo-50" : ""}`}
                    >
                      <td className="px-4 py-3">
                        <input
                          type="checkbox"
                          checked={selectedCheckbox === index}
                          onChange={() => handleCheckboxChange(index)}
                        />
                      </td>

                      <td className="px-4 py-3">
                        <label className="flex items-center gap-2">
                          <input
                            type="radio"
                            name={`mode-${index}`}
                            // checked={selectedModes[index] === "IMPS"}
                            checked={true}
                            onChange={() => handleModeChange(index, "IMPS")}
                            disabled={selectedCheckbox !== index}
                          />
                          IMPS
                        </label>
                      </td>

                      <td className="px-4 py-3 font-medium">{item.beneficiaryName}</td>
                      <td className="px-4 py-3">{item.bankName}</td>
                      <td className="px-4 py-3">{item.accountNo}</td>
                      <td className="px-4 py-3">{item.ifscCode}</td>

                      <td className="px-4 py-3">
                        <span className={`px-3 py-1 rounded-full text-xs font-semibold
                  ${item.verificationStatus === "APPROVED"
                            ? "bg-emerald-100 text-emerald-700"
                            : item.verificationStatus === "Pending"
                              ? "bg-amber-100 text-amber-700"
                              : "bg-rose-100 text-rose-700"
                          }`}>
                          {item.verificationStatus}
                        </span>
                      </td>

                      <td className="px-4 py-3">
                        <input
                          type="text"
                          inputMode="numeric"
                          placeholder="₹ Amount"
                          value={amounts[index] || ""}
                          disabled={selectedCheckbox !== index}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (/^\d{0,5}$/.test(val)) handleAmountChange(index, val);
                          }}
                          className="w-full px-3 py-2 rounded-lg border border-slate-300"
                        />
                      </td>

                      <td className="px-4 py-3">
                        <button
                          onClick={() => handleDeleteClick(item.beneficiaryId)}
                          disabled={selectedCheckbox !== index}
                          className={`px-3 py-1.5 rounded-lg text-xs font-semibold
                    ${selectedCheckbox === index
                              ? "bg-rose-500 text-white"
                              : "bg-slate-200 text-slate-400"
                            }`}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            {error && (
              <div className="px-6 py-4 text-sm text-rose-600">
                {error}
              </div>
            )}

            <div className="flex justify-end px-6 py-5 border-t border-slate-200">
              <button
                onClick={handleProcess}
                className="px-8 py-3 rounded-xl font-semibold text-white
                   bg-gradient-to-r from-indigo-600 to-cyan-500"
              >
                Proceed
              </button>
            </div>
          </div>
        </div>

      </div>

      {/* DELETE CONFIRMATION POPUP — unchanged */}
      {showDeletePopup && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm
                      flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl">
            <h3 className="text-lg font-semibold mb-3">
              Confirm Delete
            </h3>
            <p className="text-slate-600 mb-6">
              Are you sure you want to delete
              <span className="block font-medium text-slate-800 mt-1">
                {beneficiaries[selectedCheckbox]?.beneficiaryName}
              </span>
            </p>

            <div className="flex justify-end gap-3">
              <button
                onClick={handleCancelDelete}
                className="px-4 py-2 rounded-lg bg-slate-200"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteBeneficiary}
                className="px-4 py-2 rounded-lg bg-rose-500 text-white"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );


};

export default PpiRemitter;